//@flow
import LocalizedStrings from "react-localization";
import { strings as sharedStrings } from "cockpit-shared";

export const stringsRepo = new LocalizedStrings({
  en: sharedStrings.en,
  de: sharedStrings.de
});